import { render, staticRenderFns } from "./couponSettingStore.vue?vue&type=template&id=f8985b14&"
import script from "./couponSettingStore.vue?vue&type=script&lang=js&"
export * from "./couponSettingStore.vue?vue&type=script&lang=js&"
import style0 from "./couponSettingStore.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports